module.exports = "/_next/static/images/ltc-eb0eaa3c3ed2f89f71ba0efe82af81fa.svg";